/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';

/**
 * GetServiceTicketDetail Input Action
 */
export class GetServiceTicketDetailInput implements Msdyn365.IActionInput {
    public ticketId: string;
    constructor(ticketId: string) {
        this.ticketId = ticketId;
    }

    public getCacheKey = () => `GetServiceTicketDetailKey-${this.ticketId}`;
    public getCacheObjectType = () => 'GetServiceTicketDetail';
    public dataCacheType = (): Msdyn365.CacheType => 'none';
}

export interface IGetServiceTicketDetailData {
    '@odata.context': string;
    Id: string;
    TicketNumber: string;
    AssetId: string;
    CustomerId: string;
    TypeCode: string;
    StatusCode: string;
    Priority: string;
    CreationDate: string;
    Title: string;
    Description: string;
}

const createInput = (args: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    return new GetServiceTicketDetailInput('');
};

/**
 * TODO: Use this function to call your action and process the results as needed
 */
async function action(input: GetServiceTicketDetailInput, ctx: Msdyn365.IActionContext): Promise<IGetServiceTicketDetailData> {
    const userToken = ctx.requestContext.user.token === null ? 'USERTOKEN' : ctx.requestContext.user.token;

    const response = await Msdyn365.sendRequest<IGetServiceTicketDetailData>(
        `${ctx.requestContext.apiSettings.baseUrl}Commerce/GetServiceTicketDetail(language='${ctx.requestContext.locale}', ticketId='${input.ticketId}')`,
        'get',
        {},
        {
            headers: {
                OUN: ctx.requestContext.apiSettings.oun,
                Authorization: `id_token ${userToken}`
            }
        }
    );

    if (response.status === 200 && response.data) {
        return { ...response.data };
    }

    return { ...response.data };
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IGetServiceTicketDetailData>>action,
    id: 'GetServiceTicketDetail',
    input: createInput
});
